// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__rNZT5","spinner":"spinner_spinner__Q2g9U","spin":"spinner_spin__cGAH4"};